import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { OnboardWebsiteRequestBody } from "shared";
import { Api } from "../../api.config";
import { QueryKeys } from "../../LinkGen";

export const useOnboarding = () => {
	const queryClient = useQueryClient();
	const websiteOverview = useMutation({
		mutationFn: async (dto: OnboardWebsiteRequestBody) => {
			return Api.CompanyOverviewWebsite(dto).then((x) => x.data);
		},
		onSuccess: () => {
			queryClient.removeQueries({
				queryKey: QueryKeys.Company.All(),
			});
		},
	});

	const idealCustomerProfile = useMutation({
		mutationFn: async () => {
			await Api.CompanyIdealCustomer();
			queryClient.removeQueries({
				queryKey: QueryKeys.Company.All(),
			});
		},
	});

	return {
		websiteOverview,
		idealCustomerProfile,
	};
};
